"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getJitoTipAddress = getJitoTipAddress;
const web3_js_1 = require("@solana/web3.js");
const jitoTipAddresses = ["96gYZGLnJYVFmbjzopPSU6QiEV5fGqZNyN9nmNhvrZU5", "HFqU5x63VTqvQss8hp11i4wVV8bD44PvwucfZ2bU7gRe", "Cw8CFyM9FkoMi7K7Crf6HNQqf4uEMzpKw6QNghXLvLkY", "ADaUMid9yfUytqMBgopwjb2DTLSokTSzL1zt6iGPaS49", "DfXygSm4jCyNCybVYYK6DwvWqjKee8pbDmJGcLWNDXjh", "ADuUkR4vqLUMWXxW9gh6D6L8pMSawimctcNZ5pGwDcEt", "DttWaMuVvTiduZRnguLF7jNxTgiMBZ1hyAumKUiL2KRL", "3AVi9Tg9Uo68tJfuvoKvqKNWKkC5wPdSSdeBnizKZ6jT"];
function getJitoTipAddress() {
  return new web3_js_1.PublicKey(jitoTipAddresses[Math.floor(Math.random() * jitoTipAddresses.length)]);
}
//# sourceMappingURL=jito-tip.js.map